import { render, staticRenderFns } from "./Dashboard-Page.vue?vue&type=template&id=0180d7e2&"
import script from "./Dashboard-Page.vue?vue&type=script&lang=ts&"
export * from "./Dashboard-Page.vue?vue&type=script&lang=ts&"
import style0 from "./Dashboard-Page.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports